import React from 'react'
import './index.css'
import ProgressBarWithIndicator from 'components/ProgressBarWithIndicator'

/**
 * @param minLabel
 * @param progress
 * @param maxLabel
 * @returns {JSX.Element}
 * @constructor
 */
export const ProgressBarWithIndicatorAndLabels = ({
  minLabel,
  progress,
  maxLabel
}) => {
  return (
    <div className='progress-bar-with-indicator-and-labels'>
      <div className='progress-bar-with-indicator-and-labels-container'>
        <span className='progress-bar-with-indicator-and-labels-min-label'>{minLabel}</span>
        <ProgressBarWithIndicator progress={progress} />
        <span className='progress-bar-with-indicator-and-labels-max-label'>{maxLabel}</span>
      </div>
    </div>
  )
}
